<template>
  <div class="custom-border-top">
    <div>
      <div
        v-for="button in selectedInitiative.buttons"
        class="call-section"
        style="text-align: center; padding: 5px">
        <v-icon v-if="button.type === 'FLOW'" small outlined color="blue">text_snippet</v-icon>
        <v-icon v-if="button.type === 'URL'" small outlined color="blue">open_in_new</v-icon>
        <v-icon v-if="button.type === 'QUICK_REPLY'" small outlined color="blue">reply</v-icon>
        <span style="margin-left: 5px" class="blue--text">{{ button.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    copyText(text) {
      navigator.clipboard.writeText(text);
      this.$store.commit("showSnackbar", "Texto copiado!");
    },
  },
  props: {
    selectedInitiative: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-border-top {
  border-top: 3px transparent;
}
.v-btn {
  border-radius: 10px;
}
.call-button {
  border-radius: 0px;
  background-color: transparent;
}
.call-section {
  background-color: whitesmoke;
  margin-top: -7px;
  border-radius: 0px 00px 10px 10px;
  min-height: 30px;
}
</style>
